import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
interface BreadcrumbsProps {
  items: {
    label: string;
    path?: string;
  }[];
}
export function Breadcrumbs({
  items
}: BreadcrumbsProps) {
  return <nav className="flex items-center text-sm text-club-ink/60 mb-8 overflow-x-auto whitespace-nowrap py-2" data-id="element-115">
      <Link to="/" className="hover:text-club-green transition-colors" data-id="element-116">
        Home
      </Link>
      {items.map((item, index) => <Fragment key={index} data-id="element-117">
          <ChevronRight size={14} className="mx-2 flex-shrink-0" data-id="element-118" />
          {item.path ? <Link to={item.path} className="hover:text-club-green transition-colors" data-id="element-119">
              {item.label}
            </Link> : <span className="text-club-ink font-medium" data-id="element-120">{item.label}</span>}
        </Fragment>)}
    </nav>;
}